import LandingPage from "components/LandingPage";
import EventInfo from "components/MainApp/Events/EventInfo";
import Events from "components/MainApp/Events/Events";
import TreePilotMentor from "components/MainApp/Mentor";
import NewNote from "components/MainApp/NewNote/NewNote";
import Profile from "components/MainApp/Profile";
import Settings from "components/MainApp/Settings";
import Store from "components/MainApp/Store";
import UserProfile from "components/MainApp/UserProfile";
import Users from "components/MainApp/Users";
import Login from "components/MainApp/auth/Login";
import Register from "components/MainApp/auth/Register";
import Comments from "components/MainApp/comments/Comments";
import Community from "components/MainApp/community/Community";
import Dashboard from "components/MainApp/dashboard";
import Layout from "components/MainApp/layout";
import TimerApp from "components/TimerApp/TimerApp";
import { useAuth } from "hooks/auth";
import { createBrowserRouter, useLocation, useNavigate } from "react-router-dom";

export const ROOT = "/"
export const LOGIN = "/login"
export const REGISTER = "/register"
export const PROTECTED = "/protected"
export const DASHBOARD = "/protected/timecontrol"
export const PROFILE = "/protected/profile"
export const USERS = "/protected/users"
export const USERPROFILE = "/protected/profile/:id"
export const COMMUNITY = "/protected/notes"
export const COMMENTS = "/protected/comments/:id"
export const NEWNOTE = "/protected/newnote"
export const SETTINGS = "/protected/settings"
export const TREEPILOTMENTOR = "/protected/treepilotmentor"
export const EVENTS = "/protected/events"
export const EVENTSINFO = "/protected/eventsinfo/:id"
export const STORE = "/protected/store"

export const router = createBrowserRouter([
    { path: ROOT, element: <LandingPage /> },
    { path: LOGIN, element: <Login /> },
    { path: REGISTER, element: <Register /> },
    {
        path: PROTECTED,
        element: <Layout />,
        children: [
            {
                path: DASHBOARD,
                element: <TimerApp />
            },
            {
                path: PROFILE,
                element: <Profile />
            },
            {
                path: USERS,
                element: <Users />
            },
            {
                path: TREEPILOTMENTOR,
                element: <TreePilotMentor />
            },
            {
                path: USERPROFILE,
                element: <UserProfile />
            },
            {
                path: COMMUNITY,
                element: <Community />
            },
            {
                path: COMMENTS,
                element: <Comments />
            },
            {
                path: NEWNOTE,
                element: <NewNote />
            },
            {
                path: SETTINGS,
                element: <Settings />
            },
            {
                path: EVENTS,
                element: <Events />
            },
            {
                path: EVENTSINFO,
                element: <EventInfo />
            },
            {
                path: STORE,
                element: <Store />
            }
        ]
    },

])